import { useState } from "react";
import { useOverlays } from "contexts/OverlayContext";
import { Link } from "@design-system/Link/Link";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";

interface Props {
    financialAccountId?: number;
    unsavedItemLabel?: "check" | "deposit";
}

export const ImportCashItemsButton = ({
    financialAccountId,
    unsavedItemLabel,
}: Props) => {
    const { openOverlay } = useOverlays();
    const [isConfirming, setIsConfirming] = useState(false);

    const openImporter = () => {
        openOverlay("manualCashItemImport", { financialAccountId });
    };

    return (
        <>
            <Link
                className="mr-auto"
                onClick={() => {
                    if (unsavedItemLabel) {
                        setIsConfirming(true);
                        return;
                    }
                    openImporter();
                }}
            >
                Add multiple
            </Link>
            {unsavedItemLabel && isConfirming ? (
                <ConfirmationModal
                    show
                    title={`Discard this ${unsavedItemLabel}?`}
                    question="Opening the spreadsheet importer closes this form and discards what you entered."
                    yes="Discard and import"
                    no="Keep editing"
                    yesBtnVariant="destructive"
                    onConfirm={openImporter}
                    onReject={() => setIsConfirming(false)}
                    onHide={() => setIsConfirming(false)}
                />
            ) : null}
        </>
    );
};
